package com.example.mystybag.core.helpers

interface ShortcutInterface {
    fun updateShortcuts()
    fun clearShortcuts()
    fun createShortcutsIfNeeded()
}

object ShortcutsProviderInterface {
    var shortcutProvider: ShortcutInterface? = null
}